export const SKELETON_DESKTOP_TOP_PROPS = {
    width: '6%',
    height: '20px',
    variant: 'text'
};

//# sourceMappingURL=constants.js.map